import React from "react";

export interface FormTabDefinition {
  id: string;
  label: string;
  hasError?: boolean;
}

export interface FormTabsProps {
  tabs: FormTabDefinition[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}

export const FormTabs: React.FC<FormTabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className = "",
}) => {
  return (
    <div
      className={`flex gap-1 overflow-x-auto border-b border-white/10 pb-0 ${className}`}
      role="tablist"
      aria-label="Form sections"
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onTabChange(tab.id)}
            className={`shrink-0 rounded-t-[10px] px-4 py-2.5 text-sm font-medium transition-colors ${
              isActive
                ? "border border-b-0 border-white/10 bg-surface-elevated text-emerald-200"
                : "text-white/55 hover:bg-white/[0.04] hover:text-white/80"
            }`}
          >
            <span className="flex items-center gap-2">
              {tab.label}
              {tab.hasError ? (
                <span
                  className="h-2 w-2 rounded-full bg-expense"
                  aria-label="Has validation errors"
                />
              ) : null}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export function tabHasFieldErrors<T extends string>(
  errors: Partial<Record<T, unknown>>,
  fields: T[],
): boolean {
  return fields.some((field) => errors[field] !== undefined);
}
